export const INSTANCE_TYPES = ['DATA_STUDIO', 'ADX', 'ADVERTISER'] as const;
export type IntentTopicLimitOption = { label: string; value: number };

export const INTENT_TOPIC_LIMIT_OPTIONS = [
  { label: 'Default (0)', value: 0 },
  { label: 'Tier 1 (50)', value: 50 },
  { label: 'Tier 2 (125)', value: 125 },
  { label: 'Tier 3 (250)', value: 250 },
] as const;
